<div class="login-recovery">
  <div class="login-recovery-inner"><a class="logo-right" [href]="webURL" target="_blank"><img class="logo"
        [src]='logoURL' alt="VComply" onerror="this.src='../assets/images/logo.svg';" /></a>

    <div class="login-heading">Multi-factor Authentication</div>
    <div class="login-text">Please enter the recovery code.</div>

    <div class="login-form-item">
      <div class="lable">AUTHENTICATION CODE</div>
      <div class="input-area">
        <lib-recovery-pin (onInputChange)="onPinChange($event)" [config]="{ length: 3, allowNumbersOnly: true }">
        </lib-recovery-pin>
        <span *ngIf="codeError" class="error-msg"><img src="./assets/images/alert-red.svg" alt="" />You have entered an
          incorrect authentication code</span>
      </div>
    </div>

    <div class="login-form-button">
      <button class="back-btn" (click)="back.emit()"><img src="./assets/images/arrow-left.svg" alt="" /> BACK</button>
      <button class="verify-btn" [disabled]="verifyButtonDisabled">VERIFY <img src="./assets/images/arrow-right.svg"
          alt="" /></button>
    </div>

    <div class="login-form-bottom-text">Having trouble signing in?&nbsp;<a (click)="contactSupport()">Click here to
        contact support.</a></div>
  </div>
</div>